var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 8.61328V5.61328H7.9999V8.61328H6.9999V4.61328H16.9999V8.61328H15.9999ZM17.6149 12.1133C17.8982 12.1133 18.1359 12.0176 18.3279 11.8263C18.5199 11.6349 18.6156 11.3973 18.6149 11.1133C18.6149 10.8299 18.5192 10.5926 18.3279 10.4013C18.1366 10.2099 17.8989 10.1139 17.6149 10.1133C17.3316 10.1133 17.0942 10.2093 16.9029 10.4013C16.7116 10.5933 16.6156 10.8306 16.6149 11.1133C16.6149 11.3966 16.7109 11.6343 16.9029 11.8263C17.0949 12.0183 17.3322 12.1139 17.6149 12.1133ZM15.9999 18.9983V14.4603H7.9999V18.9983H15.9999ZM16.9999 19.9983H6.9999V15.9983H3.5769V10.6133C3.5769 10.0466 3.76924 9.57161 4.1539 9.18828C4.53857 8.80495 5.0129 8.61328 5.5769 8.61328H18.4229C18.9896 8.61328 19.4646 8.80495 19.8479 9.18828C20.2312 9.57161 20.4229 10.0466 20.4229 10.6133V15.9983H16.9999V19.9983ZM19.4229 14.9983V10.6133C19.4229 10.3299 19.3272 10.0926 19.1359 9.90128C18.9446 9.70995 18.7069 9.61395 18.4229 9.61328H5.5769C5.29357 9.61328 5.0559 9.70928 4.8639 9.90128C4.6719 10.0933 4.57624 10.3306 4.5769 10.6133V14.9983H6.9999V13.4603H16.9999V14.9983H19.4229Z",
    fill: "#2A3C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print-icon.86beedc80742350ec14c917494e94ff5.svg";
export { ForwardRef as ReactComponent };